import React, {useState, useEffect} from 'react'
import './ShopList.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShop, faXmark } from '@fortawesome/free-solid-svg-icons';
import fetchData from '../../../function/fetchData';
import OneItemOfShop from './OneItemOfShop'
import CloseButton from 'react-bootstrap/CloseButton';


const ShopList = ({setShowShop, server, token}) => {
    const [shopItems, setShopItems] = useState([])

    useEffect(()=> {
        if(token){
            fetchData(server + "api2/shop.php", {token: token, type: "SHOW"}).then((res)=> {
                if(res.status === 'OK'){
                    setShopItems(res.shopItems)
                }
            })
        }

    }, [token])


    const handleBlur = (id, price) => {
        fetchData(server + "api2/shop.php", {token: token, type: "UPDATE", payload: {id, price }})
    };



    return (
        <div style={{position:'relative'}}>
            <div className='header' style={{background: '#eee', borderRadius: 0, position: 'fixed', top: 0}}>
                <h3><FontAwesomeIcon icon={faShop} color={'black'} style={{marginRight: 10}}/>Shop</h3>
                <CloseButton onClick={()=>setShowShop(false)}/>
            </div>
            <div className="container" style={{marginTop: 70, padding: 20}}>
                {shopItems.map(oneItem => {
                    return <OneItemOfShop item={oneItem} handleBlur={handleBlur} key={oneItem.id}/> 
                })}
                
            </div>
        </div>
    )
}

export default ShopList
